import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = {
    url: String,
    param: String,
    enabled: { type: Boolean, default: true }
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      animation: 300,
      swapThreshold: 0.8,
      ghostClass: "sortable-ghost",
      handle: '.drag-handle',
      disabled: !this.enabledValue,
      onEnd: this.handleSortEnd.bind(this)
    })
    this.updateHandles(this.enabledValue)
  }

  setEnabled(enabled) {
    this.sortable.option("disabled", !enabled)
    this.updateHandles(enabled)
  }

  handleToggle(event) {
    this.setEnabled(event.detail.enabled)
  }

  updateHandles(enabled) {
    this.element.querySelectorAll(".drag-handle").forEach(handle => {
      handle.classList.toggle("w-5", enabled)
      handle.classList.toggle("opacity-100", enabled)
      handle.classList.toggle("mr-3", enabled)
      handle.classList.toggle("w-0", !enabled)
      handle.classList.toggle("opacity-0", !enabled)
      handle.classList.toggle("mr-0", !enabled)
    })
  }

  handleSortEnd(event) {
    const itemIds = Array.from(this.element.children).map(item => item.dataset.id)
    
    if (this.urlValue && itemIds.length > 0) {
      const formData = new FormData()
      // Append each ID separately to create an array
      itemIds.forEach(id => {
        formData.append(`${this.paramValue || 'question_answer_ids'}[]`, id)
      })
      
      fetch(this.urlValue, {
        method: 'PATCH',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
      })
      .catch(error => {
        console.error('Error reordering items:', error)
        // Optionally show user feedback
      })
    }
  }
}
